export default "__VITE_ASSET__j2QFx_kE__"